// src/config.js
const BASE_URL = "https://api.ken-lib.com"; 

// const BASE_URL = "http://127.0.0.1:8000";

export default BASE_URL;
